import IRouter from "../../../interfaces/IRouter"
import { EditLiveExamDropDownRouter } from "../../../Router"

interface ICentersIndex {
    children: IRouter[]
}

const TestLiveExamIndex = (props: ICentersIndex) => {
    return (
        <>
            <EditLiveExamDropDownRouter children={props.children} />
        </>
    )
}

export default TestLiveExamIndex